/**
 * Any assessmentAdministration API calls with React Query.
 */
import { useMemo } from "react";
import { GetAssesmentsDropdownCancelToken, GetAssesmentsListCancelToken } from "../../services/DashBoardServices";
import { QUERY_CACHE_PROFILES, QUERY_KEYS } from "../queryConsts";
import { useBaseReactQuery } from "./useBaseReactQuery";

const EMPTY_ASSESSMENT_DROPDOWN = Object.freeze({
    course: [],
    intake: [],
    learning: [],
    typeFilter: [],
    actualTypeFilter: [],
    showing: [],
});

const EMPTY_ASSESSMENT_LIST = Object.freeze({
    assessmentList: [],
    totalRows: 0
});

/**
 * Assessment Dropdown - PERSISTED
 * @param {AssessmentAdministrationTabNames} Tab Assesment Tab name.
 * @returns {DefinedUseQueryResult} React Query result
 */
export function useAssessmentDropdown(filters) {
    const query = useBaseReactQuery(
        [QUERY_KEYS.assessmentAdministration.root, QUERY_KEYS.assessmentAdministration.assessmentDropdown, filters],
        async () => {
            const { data } = await GetAssesmentsDropdownCancelToken(filters);

            return data;
        },
        {
            cacheProfile: QUERY_CACHE_PROFILES.LOOKUP
        }
    );

    return {
        ...query,
        data: query.data ?? EMPTY_ASSESSMENT_DROPDOWN
    };
}

/**
 * React Query hook for Assessment lists.
 * The requestData should already be in the format expected by the API.
 *
 * @param {object} requestData Request body passed directly to the API.
 * @returns {DefinedUseQueryResult}
 */
export function useAssessmentList(requestData) {
    const query = useBaseReactQuery(
        [
            QUERY_KEYS.assessmentAdministration.root,
            QUERY_KEYS.assessmentAdministration.assessmentList,
            requestData
        ],
        async () => {
            const { data } = await GetAssesmentsListCancelToken(requestData);

            return {
                assessmentList: data?.result ?? [],
                totalRows: data?.Pagination?.total ?? 0
            };
        },
        {
            cacheProfile: QUERY_CACHE_PROFILES.TABLE
        }
    );

    return {
        ...query,
        data: query.data ?? EMPTY_ASSESSMENT_LIST
    };
}
